::ng-deep app-create-questionnaire-from-excel-dialog{display:flex}
/*# sourceMappingURL=create-questionnaire-from-excel-dialog.component-LHBIWFLH.css.map */
